export enum ROUTES {
    START = 'https://alexander-buerkle.com',
    NEWS = '/magazin',
    PROMOTION = '/promotion',
    SERVICES = '/services',
    PRIVACY = '/datenschutz',
    SHOP = '/mein-shop',
    LASTBOUGHTPRODUCTS = '/zuletzt-gekaufte-produkte',
    ORDERS = '/meine-belege',
    ORDER = '/beleg-details',
    PRODUCTPAGE = '/produkt',
    CATEGORY = '/kategorie',
    SEARCH = '/suche',
    OFFERS = '/meine-angebote',
    OFFERDETAILS = '/angebot-details',
    CART = '/warenkorb',
    CARTS = '/meine-warenkoerbe',
    ACCESSMANAGEMENT = '/zugangsverwaltung',
    CHECKOUT = '/bestelluebersicht',
    CHECKOUT_OFFER = '/angebot-bestelluebersicht',
    CHECKOUTSUCCESS = '/bestellung-erfolgreich',
    SHOPPINGLISTS = '/listen',
    SHOPPINGLIST = '/liste',
    SIGNUP = '/kunde-werden',
    SINGUPSUCCESS = '/registrierung-abgeschlossen',
    CABLEREEL = '/abholung-kabeltrommel',
    CABLEREELSUCCESS = '/kabeltrommel-gesendet',
    RETURNS = '/meine-retouren',
    RETURNCHECKIN = '/retoure-anmelden',
    RETURNCHECKOUT = '/retoure-checkout',
    RETURNSUCCESS = '/retoure-erfolgreich',
    USER_CONFIGURATOR = '/benutzer-verwalten',
    ACCOUNT_CONFIGURATOR = '/account-verwalten',
    OWN_USER = '/eigener-benutzer',
    OXOMICATALOGUES = '/kataloge',
    OXOMI_NAVIGATOR = '/navigator',
    SCANNER = '/scanner',
    FASTENTRY = '/schnellerfassung',
    BARCODELIST = '/barcode-liste',
    CHANGELOG = '/neuigkeiten',
    FAQ = '/faq',
    PROMOTIONALSHEET = '/aktionsblatt',
    ELBRIDGE = '/elbridge',
    CONFIGURATORS = '/konfiguratoren',
    CABLEDEALMARKET = '/kabelschnaeppchen',
    NEWSLETTER = '/newsletter-anmeldung',
    PRODUCT_COMPARE = '/produkt-vergleich',
    CREDIT_INFO = '/credits-info',
    CREDITS_DONATED_SUCCESS = '/credits-donated-success',
    HELP = '/hilfe',
    PROMOTION_HELP = '/promotion/hilfe',
    KANBAN = '/etiketten',
    ONBOARDING = '/onboarding',
    PRAEMIEN_SHOP = '/praemienshop',
    PRAEMIEN_SHOP_DETAIL = '/praemienshop-detail',
    PRAEMIEN_SHOP_CART = '/praemienshop-warenkorb',
    PRAEMIEN_SHOP_REGISTER = '/praemienshop-anmelden',
    PRAEMIEN_SHOP_SPEND_POINTS = '/praemienshop-punkte-spenden',
    PRAEMIEN_SHOP_MARKETING_LINK = '/jubilaeumsaktion',
    PRAEMIEN_SHOP_SUCCESS = '/praemienshop-bestellung-erfolgreich',
    PRAEMIEN_SHOP_DONATION_SUCCESS = '/praemienshop-spende-erfolgreich',
    RECEIPT = '/wareneingang',
    SERVICE_DIRECTORY = '/leistungsverzeichnis',
    SERVICE_DIRECTORY_DETAIL = '/leistungsverzeichnis-detail',
    CALLBACK = '/callback'
}
